import "./style.css";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import gsap from "gsap";

/**
 * Popup
 */
// const popUpLogo = document.querySelector(".pop-up_logo");
// console.log(popUpLogo);
// popUpLogo.setAttribute("src", "./Logo/canza-ctm-dark.svg");

/**
 * DOM
 */
var contentNumber = 5;
const detailsContainer = document.querySelector(".pop-up");
const detailsContainer2 = document.querySelector(".pop-up2");
const detailsContainer3 = document.querySelector(".pop-up3");
const backBtn = document.querySelectorAll(".back");

const aboutText = document.getElementById("about-text");

const content = [
  {
    name: "mobile",
    about: "This is a mobile store",
    buttonLink: "",
    productOwner: "",
    logoLink: "",
  },
  {
    name: "atm",
    about: "This is a atm",
    buttonLink: "",
    productOwner: "",
    logoLink: "",
  },
  {
    name: "resturant",
    about: "This is a resturant",
    buttonLink: "",
    productOwner: "",
    logoLink: "",
  },
  {
    name: "research",
    about: "This is a research center",
    buttonLink: "",
    productOwner: "",
    logoLink: "",
  },
  {
    name: "bank",
    about: "This is a bank",
    buttonLink: "",
    productOwner: "",
    logoLink: "",
  },
];
function contentChanger() {
  aboutText.innerText = content[contentNumber].about;
  console.log(content[contentNumber].about);
  console.log(contentNumber);
}

/**
 * Base
 */
// Canvas
const canvas = document.querySelector("canvas.webgl");
var cameraMove,
  state,
  storeArray = [];

state = null;
var envGroup = new THREE.Group();
var storeGroup = [];
envGroup.visible = true;
// Scene
const scene = new THREE.Scene();
scene.add(envGroup);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Loader
 */
const loadingManager = new THREE.LoadingManager(
  () => {
    const loader = document.querySelector(".loading");
    loader.style.display = "none";
    // console.log("loader");
  },
  () => {
    // console.log("Progress");
  }
);
const gltfLoader = new GLTFLoader(loadingManager);
const textureLoader = new THREE.TextureLoader(loadingManager);

/**
 * Enviroment Loader
 */
// Texture
const enviromentTexture = textureLoader.load(
  "./Backings/Enviroment/enviromentBlackHuman.jpg"
);
enviromentTexture.flipY = false;
enviromentTexture.encoding = THREE.sRGBEncoding;

// Material
const enviromentMaterial = new THREE.MeshBasicMaterial({
  map: enviromentTexture,
});

// GLTF Loader
gltfLoader.load("./Gltf/enviroment.glb", (obj) => {
  obj.scene.traverse((child) => {
    if (child.isMesh) {
      child.material = enviromentMaterial;
    }
  });
  envGroup.add(obj.scene);
});

/**
 * Mobile Loader
 */
// Texture
const mobileTexture = textureLoader.load(
  "./Backings/Mobile Store/mobileStoreBlackHuman.jpg"
);
mobileTexture.flipY = false;
mobileTexture.encoding = THREE.sRGBEncoding;

// Material
const mobileMaterial = new THREE.MeshBasicMaterial({ map: mobileTexture });

// GLTF Loader
gltfLoader.load("./Gltf/mobileStore.glb", (obj) => {
  obj.scene.traverse((child) => {
    storeArray.push(child);
    if (child.isMesh) {
      child.material = mobileMaterial;
    }
  });
  storeGroup.push(obj.scene);
  obj.scene.position.set(0.018578, 0.234018, 1.54761);
  obj.scene.name = "mobile";
  scene.add(obj.scene);
});

/**
 * Research Loader
 */
// Texture
const researchTexture = textureLoader.load(
  "./Backings/Research Centre/Research Centre V3.jpg"
);
researchTexture.flipY = false;
researchTexture.encoding = THREE.sRGBEncoding;

// Material
const researchMaterial = new THREE.MeshBasicMaterial({ map: researchTexture });

// GLTF Loader
gltfLoader.load("./Gltf/V1/researchCentre.glb", (obj) => {
  obj.scene.traverse((child) => {
    storeArray.push(child);
    if (child.isMesh) {
      child.material = researchMaterial;
    }
  });
  storeGroup.push(obj.scene);
  // obj.scene.position.set(0.297979, 0.787443, -2.37699);
  obj.scene.position.set(0.297979, 0.7872, -2.37699);
  obj.scene.name = "research";
  scene.add(obj.scene);
});

/**
 * ATM Loader
 */
// Texture
const atmTexture = textureLoader.load("./Backings/Atm/atmBlackHuman.jpg");
atmTexture.flipY = false;
atmTexture.encoding = THREE.sRGBEncoding;

// Material
const atmMaterial = new THREE.MeshBasicMaterial({ map: atmTexture });

// GLTF Loader
gltfLoader.load("./Gltf/atm.glb", (obj) => {
  obj.scene.traverse((child) => {
    storeArray.push(child);
    if (child.isMesh) {
      child.material = atmMaterial;
    }
  });
  storeGroup.push(obj.scene);
  obj.scene.position.set(2.30016, 0.34444, -0.162749);
  obj.scene.name = "atm";
  scene.add(obj.scene);
});

/**
 * Bank Loader
 */
// Texture
const bankTexture = textureLoader.load("./Backings/Bank/bankBlackHuman.jpg");
bankTexture.flipY = false;
bankTexture.encoding = THREE.sRGBEncoding;

// Material
const bankMaterial = new THREE.MeshBasicMaterial({ map: bankTexture });

// GLTF Loader
gltfLoader.load("./Gltf/V1/bank.glb", (obj) => {
  obj.scene.traverse((child) => {
    storeArray.push(child);
    if (child.isMesh) {
      child.material = bankMaterial;
    }
  });
  storeGroup.push(obj.scene);
  // obj.scene.position.set(-2.21327, 0.583028, -0.984673);
  obj.scene.position.set(-2.21327, 0.582, -0.984673);
  obj.scene.name = "bank";
  scene.add(obj.scene);
});

/**
 * Resturant Loader
 */
// Texture
const resturantTexture = textureLoader.load(
  "./Backings/Restaurant/restaurantBlackHuman.jpg"
);
resturantTexture.flipY = false;
resturantTexture.encoding = THREE.sRGBEncoding;

// Material
const resturantMaterial = new THREE.MeshBasicMaterial({
  map: resturantTexture,
});

// GLTF Loader
gltfLoader.load("./Gltf/restaurant.glb", (obj) => {
  obj.scene.traverse((child) => {
    storeArray.push(child);
    if (child.isMesh) {
      child.material = resturantMaterial;
    }
  });
  storeGroup.push(obj.scene);
  // obj.scene.position.set(2.09934, 0.326127, 1.31695);
  obj.scene.position.set(2.09934, 0.321, 1.31695);
  obj.scene.name = "resturant";
  scene.add(obj.scene);
});

/**
 * Car Loader
 */
// Texture
const carTexture = textureLoader.load("./Car/car.jpg");
carTexture.flipY = false;
carTexture.encoding = THREE.sRGBEncoding;

// Material
const carMaterial = new THREE.MeshBasicMaterial({
  map: carTexture,
});

// GLTF Loader
var carAnimationMixer, carAnimationAction;
gltfLoader.load("./Car/car.glb", (obj) => {
  obj.scene.traverse((child) => {
    if (child.isMesh) {
      child.material = carMaterial;
    }
  });
  carAnimationMixer = new THREE.AnimationMixer(obj.scene);
  carAnimationAction = carAnimationMixer.clipAction(obj.animations[0]);
  carAnimationAction.play();
  envGroup.add(obj.scene);
});

/**
 * Fan Loader
 */
// Texture
const fanStandTexture = textureLoader.load("./Fan/FanStandV1.jpg");
fanStandTexture.flipY = false;
fanStandTexture.encoding = THREE.sRGBEncoding;

const fanBladeTexture = textureLoader.load("./Fan/FanBlade.jpg");
fanBladeTexture.flipY = false;
fanBladeTexture.encoding = THREE.sRGBEncoding;

// Material
const fanStandMaterial = new THREE.MeshBasicMaterial({
  map: fanStandTexture,
});
const fanBladeMaterial = new THREE.MeshBasicMaterial({
  map: fanBladeTexture,
});

// GLTF Loader
var fanAnimationMixer, fanAnimationAction;
gltfLoader.load("./Fan/fan.glb", (obj) => {
  obj.scene.traverse((child) => {
    if (
      child.name === "FanStand" ||
      child.name === "FanStand001" ||
      child.name === "FanStand002"
    ) {
      child.material = fanStandMaterial;
    }
    if (
      child.name === "Blades_01001" ||
      child.name === "Blades_01002" ||
      child.name === "Blades_01003"
    ) {
      child.material = fanBladeMaterial;
    }
  });
  fanAnimationMixer = new THREE.AnimationMixer(obj.scene);
  fanAnimationAction = obj.animations.forEach((ani) => {
    let animation = fanAnimationMixer.clipAction(ani);
    animation.play();
  });
  envGroup.add(obj.scene);
});

/**
 * Train Loader
 */
// Texture
const trainTexture1 = textureLoader.load("./Train/Train1.jpg");
trainTexture1.flipY = false;
trainTexture1.encoding = THREE.sRGBEncoding;

const trainTexture2 = textureLoader.load("./Train/Train2.jpg");
trainTexture2.flipY = false;
trainTexture2.encoding = THREE.sRGBEncoding;

const trainTexture3 = textureLoader.load("./Train/Train3.jpg");
trainTexture3.flipY = false;
trainTexture3.encoding = THREE.sRGBEncoding;

// Material
const trainMaterial1 = new THREE.MeshBasicMaterial({
  map: trainTexture1,
});
const trainMaterial2 = new THREE.MeshBasicMaterial({
  map: trainTexture2,
});
const trainMaterial3 = new THREE.MeshBasicMaterial({
  map: trainTexture3,
});

// GLTF Loader
var trainAnimationMixer, trainAnimationAction;
gltfLoader.load("./Train/train.glb", (obj) => {
  obj.scene.traverse((child) => {
    if (child.name === "Train1") {
      child.traverse((subChild) => {
        subChild.material = trainMaterial1;
      });
    }
    if (child.name === "Train2") {
      child.traverse((subChild) => {
        subChild.material = trainMaterial2;
      });
    }
    if (child.name === "Train3") {
      child.traverse((subChild) => {
        subChild.material = trainMaterial3;
      });
    }
  });
  trainAnimationMixer = new THREE.AnimationMixer(obj.scene);
  trainAnimationAction = obj.animations.forEach((ani) => {
    let animation = trainAnimationMixer.clipAction(ani);
    animation.play();
  });

  envGroup.add(obj.scene);
});

/**
 * Helicopter Loader
 */
// Texture
const heliTexture = textureLoader.load("./Helicopter/Heli.jpg");
heliTexture.flipY = false;
heliTexture.encoding = THREE.sRGBEncoding;

const heliFanTexture = textureLoader.load("./Helicopter/HeliFan.jpg");
heliFanTexture.flipY = false;
heliFanTexture.encoding = THREE.sRGBEncoding;

// Material
const heliMaterial = new THREE.MeshBasicMaterial({
  map: heliTexture,
});
const heliFanMaterial = new THREE.MeshBasicMaterial({
  map: heliFanTexture,
});

// GLTF Loader
var heliAnimationMixer, heliAnimationAction;
gltfLoader.load("./Helicopter/Heli Animation Fix.glb", (obj) => {
  obj.scene.traverse((child) => {
    console.log(child);
    if (child.name === "uploads_files_3310181_Helicopter001") {
      child.material = heliFanMaterial;
    }
    if (child.name === "uploads_files_3310181_Helicopter") {
      child.traverse((subChild) => {
        subChild.material = heliMaterial;
      });
    }
  });
  heliAnimationMixer = new THREE.AnimationMixer(obj.scene);
  heliAnimationAction = obj.animations.forEach((ani) => {
    let animation = heliAnimationMixer.clipAction(ani);
    animation.play();
  });
  envGroup.add(obj.scene);
});

/**
 * Basekat Ball Loader
 */
// Texture
const ballTexture = textureLoader.load("./Basketball/ball.jpg");
ballTexture.flipY = false;
ballTexture.encoding = THREE.sRGBEncoding;

const netTexture = textureLoader.load("./Basketball/net.jpg");
netTexture.flipY = false;
netTexture.encoding = THREE.sRGBEncoding;

const playerTexture = textureLoader.load("./Basketball/player.jpg");
playerTexture.flipY = false;
playerTexture.encoding = THREE.sRGBEncoding;

// Material
const ballMaterial = new THREE.MeshBasicMaterial({
  map: ballTexture,
});
const netMaterial = new THREE.MeshBasicMaterial({
  map: netTexture,
});
const playerMaterial = new THREE.MeshBasicMaterial({
  map: playerTexture,
});

// GLTF Loader
var ballAnimationMixer, ballAnimationAction;
gltfLoader.load("./Basketball/ball.glb", (obj) => {
  obj.scene.traverse((child) => {
    child.material = ballMaterial;
  });
  ballAnimationMixer = new THREE.AnimationMixer(obj.scene);
  ballAnimationAction = ballAnimationMixer.clipAction(obj.animations[0]);
  ballAnimationAction.play();
  envGroup.add(obj.scene);
});

gltfLoader.load("./Basketball/net.glb", (obj) => {
  obj.scene.traverse((child) => {
    child.material = netMaterial;
  });

  envGroup.add(obj.scene);
});
var playerAnimationMixer, playerAnimationAction;
gltfLoader.load("./Gltf/V1/player.glb", (obj) => {
  obj.scene.traverse((child) => {
    // child.material = playerMaterial;
  });
  playerAnimationMixer = new THREE.AnimationMixer(obj.scene);
  playerAnimationAction = playerAnimationMixer.clipAction(obj.animations[0]);
  playerAnimationAction.play();

  envGroup.add(obj.scene);
});

/**
 * Ground
 */
var groundObj;
gltfLoader.load("./ground.glb", (obj) => {
  obj.scene.traverse((child) => {
    child.material = new THREE.MeshBasicMaterial({ color: 0x86d794 });
  });

  obj.scene.position.x = -0.5;
  obj.scene.position.y = 0;
  obj.scene.position.z = 0.1;
  // obj.scene.scale.set(0.3, 0.5, 0.5);
  // obj.scene.visible = false;
  envGroup.add(obj.scene);

  // scene.add(obj.scene);
  groundObj = obj.scene;
});

/**
 * Light
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 1);
scene.add(ambientLight);

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  40,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.set(-4, 4, 6);
camera.lookAt(new THREE.Vector3(0, 0, 0));
camera.zoom = 1;
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.touches.ONE = THREE.TOUCH.PAN;

controls.enableDamping = true;
controls.enableRotate = false;
controls.enableZoom = false;

/**
 * Raycaster
 */
const raycaster = new THREE.Raycaster();
const raycasterHover = new THREE.Raycaster();
const raycasterCenter = new THREE.Raycaster();
const raycasterCenterHover = new THREE.Raycaster();
const pointer = new THREE.Vector2(-1, -1);
const hoverPointer = new THREE.Vector2(-1, -1);

const { x, y } = camera.position;

canvas.addEventListener("mousemove", function (event) {
  hoverPointer.x = (event.clientX / window.innerWidth) * 2 - 1;
  hoverPointer.y = -(event.clientY / window.innerHeight) * 2 + 1;

  camera.position.x = x + ((event.clientX / window.innerWidth) * 2 - 1) * 0.2;
  camera.position.y = y + (-(event.clientY / window.innerHeight) * 2 + 1) * 0.2;

  // camera.position.x += (-(event.clientX / window.innerWidth) + 0.5) * 0.01;
  // camera.position.y += (event.clientY / window.innerHeight - 0.5) * 0.01;
  // camera.position.x += (event.clientX / window.innerWidth - 0.5) * 0.02;

  // camera.position.y =
  //   camera.position.y + (event.clientY / window.innerHeight - 0.5) * 0.02;
});

console.log(camera);

canvas.addEventListener("click", function (event) {
  pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
  pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
});
canvas.addEventListener("touchstart", function (event) {
  pointer.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1;
  pointer.y = -(event.touches[0].clientY / window.innerHeight) * 2 + 1;
});

/**
 * Mouse Movement
 */
var mousemove = { x: 0, y: 0 };
window.addEventListener("mousemove", (e) => {
  mousemove.x = e.clientX / sizes.width - 0.5;
  mousemove.y = e.clientY / sizes.height - 0.5;
});

/**
 * Renderer
 */

const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.setClearColor(0xeeeeee);
// Back
backBtn[1].onclick = function () {
  console.log(camera);
  contentNumber = 5;
  canvas.style.pointerEvents = "auto";
  detailsContainer.style.display = "none";
  detailsContainer2.style.display = "none";
  detailsContainer3.style.display = "none";
  pointer.x = -1;
  pointer.y = -1;
  intersects = [];
  state = false;
  if (envGroup.visible === false) {
    envGroup.visible = true;
    storeGroup.map((i) => (i.visible = true));
  }
  var timeline2 = gsap.timeline();
  camera.position.set(-4, 4, 6);
  camera.zoom = 1;
  camera.lookAt(new THREE.Vector3(0, 0, 0));
  timeline2
    .add("end")
    .to(
      camera,
      {
        duration: 2.1,
        zoom: 1,
        onUpdate: function () {
          camera.updateProjectionMatrix();
        },
      },
      "end"
    )
    .to(
      camera.position,
      {
        x: -4,
        y: 4,
        z: 6,
        onUpdate: function () {
          camera.updateProjectionMatrix();
        },
      },
      "end"
    );
  if (camera.zoom !== 1) {
    camera.zoom = 1;
  }
};
backBtn[0].onclick = function () {
  console.log(camera);
  contentNumber = 5;
  canvas.style.pointerEvents = "auto";
  detailsContainer.style.display = "none";
  detailsContainer2.style.display = "none";
  detailsContainer3.style.display = "none";
  pointer.x = -1;
  pointer.y = -1;
  intersects = [];
  state = false;
  if (envGroup.visible === false) {
    envGroup.visible = true;
    storeGroup.map((i) => (i.visible = true));
  }
  var timeline2 = gsap.timeline();
  camera.position.set(-4, 4, 6);
  camera.zoom = 1;
  camera.lookAt(new THREE.Vector3(0, 0, 0));
  timeline2
    .add("end")
    .to(
      camera,
      {
        duration: 2.1,
        zoom: 1,
        onUpdate: function () {
          camera.updateProjectionMatrix();
        },
      },
      "end"
    )
    .to(
      camera.position,
      {
        x: -4,
        y: 4,
        z: 6,
        onUpdate: function () {
          camera.updateProjectionMatrix();
        },
      },
      "end"
    );
  if (camera.zoom !== 1) {
    camera.zoom = 1;
  }
};
/**
 * Animate
 */
var intersects,
  intersectsHover,
  intersectsCenter,
  intersectsCenterHover,
  emptyChecker,
  hovered,
  hoveredCenter;
const clock = new THREE.Clock();

const tick = () => {
  const elapsedTime = clock.getElapsedTime();

  // Controls
  controls.update();

  // Raycaster
  raycaster.setFromCamera(pointer, camera);
  raycasterHover.setFromCamera(hoverPointer, camera);
  raycasterCenter.setFromCamera(pointer, camera);
  raycasterCenterHover.setFromCamera(hoverPointer, camera);

  if (groundObj) {
    intersectsCenter = raycasterCenter.intersectObjects(groundObj.children);
    intersectsCenterHover = raycasterCenterHover.intersectObjects(
      groundObj.children
    );

    if (intersectsCenterHover.length > 0) {
      hoveredCenter = true;
      // window.document.body.style.cursor = "pointer";
    } else {
      hoveredCenter = false;
      // document.body.style.cursor = "auto";
    }

    if (intersectsCenter.length > 0) {
      canvas.style.pointerEvents = "none";
      pointer.x = -1;
      pointer.y = -1;
      state = false;
      var timeline3 = gsap.timeline();

      timeline3
        .add("center")
        .to(
          camera,
          {
            duration: 2,
            zoom: 1,
            onUpdate: function () {
              camera.updateProjectionMatrix();
            },
          },
          "center"
        )
        .to(
          camera.position,
          {
            x: 0,
            y: 8,
            z: 0.2,
            onUpdate: function () {
              camera.updateProjectionMatrix();
            },
          },
          "center"
        );
      camera.lookAt(new THREE.Vector3(0, 0, 0));
      detailsContainer2.style.display = "block";
      detailsContainer3.style.display = "flex";
    }
  }

  if (storeArray.length > 0) {
    intersects = raycaster.intersectObjects(storeArray);
    intersectsHover = raycasterHover.intersectObjects(storeArray);

    if (intersectsHover.length > 0) {
      hovered = true;
      // document.body.style.cursor = "pointer";
    } else {
      hovered = false;
      // document.body.style.cursor = "auto";
    }

    if (intersects.length > 0) {
      detailsContainer.style.display = "block";
      state = intersects[0].object.parent.parent;
      state.name;
      if (contentNumber === 5) {
        switch (state.name) {
          case "mobile":
            contentNumber = 0;
            console.log("Mobile Logged");
            break;
          case "atm":
            contentNumber = 1;
            console.log("atm Logged");
            break;
          case "resturant":
            contentNumber = 2;
            console.log("resturant Logged");
            break;
          case "bank":
            contentNumber = 4;
            console.log("bank Logged");
            break;
          case "research":
            contentNumber = 3;
            console.log("research Logged");
            break;
          default:
            break;
        }
        contentChanger();
      }
    }
  }

  if (state && pointer.x !== -1) {
    // console.log(camera);
    canvas.style.pointerEvents = "none";
    var timeline1 = gsap.timeline();
    camera.lookAt(state.position);
    timeline1
      .add("start")
      .to(
        camera,
        {
          duration: 2,
          zoom: 4,
          onUpdate: function () {
            camera.updateProjectionMatrix();
          },
        },
        "start"
      )
      .to(
        camera.position,
        {
          x: state.position.x - 5,
          y: 2,
          z: Math.abs(state.position.z) + 8,
          onUpdate: function () {
            camera.updateProjectionMatrix();
          },
        },
        "start"
      );

    envGroup.visible = false;
    const emptyarr = storeGroup.filter((i) => i.uuid !== state.uuid);
    emptyarr.map((i) => (i.visible = false));
  } else {
  }

  if (!hovered || !hoveredCenter) {
    document.body.style.cursor = "auto";
  }
  if (hovered || hoveredCenter) {
    document.body.style.cursor = "pointer";
  }

  // Animation
  if (
    carAnimationMixer &&
    fanAnimationMixer &&
    trainAnimationMixer &&
    heliAnimationMixer &&
    ballAnimationMixer &&
    playerAnimationMixer
  ) {
    carAnimationMixer.update(clock.getDelta(elapsedTime) + 0.01);
    fanAnimationMixer.update(clock.getDelta(elapsedTime) + 0.01);
    trainAnimationMixer.update(clock.getDelta(elapsedTime) + 0.01);
    heliAnimationMixer.update(clock.getDelta(elapsedTime) + 0.015);
    ballAnimationMixer.update(clock.getDelta(elapsedTime) + 0.02);
    playerAnimationMixer.update(clock.getDelta(elapsedTime) + 0.02);
  }

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
